import {AppContext} from "@lightspeed-invoicing/core-client/frontend"
import { StockDocumentDefinitionListing } from "../models"

export class Service {
    static fetchAll (): Promise<StockDocumentDefinitionListing> {
        return AppContext.getApiClient().get("/inventory-stock-document-definitions")
    }

}


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/services/service.ts